import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { NoLineBreak } from 'src/components/atoms/NoLineBreak'
import FadeDownWrap from 'src/components/atoms/FadeDown'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { Typography } from 'src/components/atoms/Typography'
import { YouTube } from 'src/components/molecules/YouTube'
import { vwSize } from 'src/utils/vwCss'
// images
import circle from 'src/images/top/commmune-circle.svg'
import h3l from 'src/images/top/h3-l.svg'
import h3r from 'src/images/top/h3-r.svg'

const TopConcept = () => {
  return (
    <Container>
      <GradientBGWrap>
        <WrapperStyle>
          <CircleImageWrap>
            <FadeDownWrap>
              <CircleImage
                src={circle}
                alt="コミュニティ・メール・API・イベント・トレーニング・ナレッジベース・アプリ・Q&A"
              />
            </FadeDownWrap>
          </CircleImageWrap>
          <Message>
            <FadeDownWrap>
              <HeadTtl>
                コミュニティを成功させる<br />全てがここに。
              </HeadTtl>
            </FadeDownWrap>
            <FadeDownWrap>
              <HeadSubTtl>
                マーケター・カスタマーサクセスのパートナー
              </HeadSubTtl>
            </FadeDownWrap>
            <FadeDownWrap>
              <Description>
                <NoLineBreak>commmuneはコミュニティに必要な機能全てをノーコードで提供。</NoLineBreak>
                <NoLineBreak>ユーザー/ファンコミュニティ・アドボカシーマーケティングを</NoLineBreak>
                <NoLineBreak>成功に導きます。</NoLineBreak>
              </Description>
            </FadeDownWrap>
          </Message>
        </WrapperStyle>

        <VideoWrap>
          <VideoContent>
            <FadeDownWrap>
              <MovieTtl className={"g-h3"}>
                <H3Text>commmune紹介動画はこちら！</H3Text>
              </MovieTtl>
              <YouTube 
                caption="" 
                url="https://www.youtube.com/embed/GEjhwsdvDnk"/>
            </FadeDownWrap>
          </VideoContent>
          <VideoContent>
            <FadeDownWrap>
              <MovieTtl className={"g-h3"}>
                <H3Text>CM公開中！</H3Text>
              </MovieTtl>
              <YouTube 
                caption="" 
                url="https://www.youtube.com/embed/BL60t3rpyuY"/>
            </FadeDownWrap>
          </VideoContent>
        </VideoWrap>
      </GradientBGWrap>
    </Container>
  )
}

const Container = styled.div`
  background-color: ${Styles.color.primary[100]};
  padding-bottom: ${vwSize(80, 'pc')}vw;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    padding-bottom: ${vwSize(80, 'sp')}vw 0;
  }
`
const GradientBGWrap = styled.div`
  background-color: ${Styles.color.primary[100]};
  background-image: radial-gradient(#fff, ${Styles.color.primary[100]});
  background-position: center center;
  background-size: $(vwSize(1322, 'pc')}vw 100%;
  width: 100%;
  height: 100%;
`
const HeadTtl = styled.h2`
  font-size: ${vwSize(36, 'pc')}vw;
  font-weight: ${Styles.fontWeight.bold};
  line-height: 1.6;
  color: ${Styles.color.primary[400]};
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    font-size: ${Styles.sp.fontSize.h2};
  }
`
const HeadSubTtl = styled.div`
  font-size: ${vwSize(24, 'pc')}vw;
  font-weight: ${Styles.fontWeight.bold};
  line-height: 1.6;
  color: ${Styles.color.primary[400]};
  margin-top: ${vwSize(8, 'pc')}vw;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    font-size: ${vwSize(20, 'sp')}vw;
    margin-top: ${vwSize(8, 'sp')}vw;
  }
`

const WrapperStyle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: ${vwSize(120, 'pc')}vw ${vwSize(180, 'pc')}vw 0;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    flex-direction: column;
    padding: ${vwSize(80, 'sp')}vw ${vwSize(20, 'sp')}vw 0;
  }
`
const Message = styled.div`
  padding: 0 ${Styles.spacing[7]};
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    order: 1;
    padding: 0;
  }
`
const Description = styled(Typography)`
  margin: ${Styles.spacing[7]} 0;
  font-size: ${Styles.pc.fontSize.text};
  line-height: 1.6;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    font-size: ${Styles.sp.fontSize.text};
    margin: ${vwSize(32, 'sp')}vw 0;
  }

`

const CircleImageWrap = styled.div`
  width: ${vwSize(620, 'pc')}vw;
  margin-right: ${vwSize(64, 'pc')}vw;
  display: block;
  box-sizing: border-box;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    order: 2;
    width: ${vwSize(240, 'sp')}vw;
    margin-right: 0;
  }
`
const CircleImage = styled.img`
  width: 100%;
`

const VideoWrap = styled.div`
  padding: 0 ${vwSize(16, 'sp')}vw ${Styles.spacing[11]};
  margin: auto;
  gap: ${Styles.spacing[10]};
  margin-top: ${vwSize(48, 'sp')}vw;
  
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    padding: 0 50px ${Styles.spacing[13]};
    margin-top: ${vwSize(80, 'pc')}vw;
    display: flex;
  }
`

const VideoContent = styled.div`

@media screen and (min-width: ${BreakPoint.TABLET}) {
  width: 50%;
}
`

const MovieTtl = styled.h3`
  text-align: center;
`
const H3Text = styled.div`
  text-align: center;
  display: inline-block;
  margin-bottom: ${vwSize(20, 'pc')}vw;
  position: relative;
  @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
    margin-bottom: ${vwSize(20, 'sp')}vw;
  }

  &:before {
    content: "";
    background-image: url(${h3l});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    width: ${vwSize(20, 'pc')}vw;
    height: ${vwSize(20, 'pc')}vw;
    position: absolute;
    left: -2em;
    top: 50%;
    transform: translateY(-50%);
    @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
      width: ${vwSize(8, 'sp')}vw;
      height: ${vwSize(24, 'sp')}vw;
      left: -1em;
    }
  }
  &:after {
    content: "";
    background-image: url(${h3r});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    width: ${vwSize(20, 'pc')}vw;
    height: ${vwSize(20, 'pc')}vw;
    position: absolute;
    right: -2em;
    top: 50%;
    transform: translateY(-50%);
    @media screen and (max-width: ${BreakPoint.MOBILE_L}) {
      width: ${vwSize(8, 'sp')}vw;
      height: ${vwSize(24, 'sp')}vw;
      right: -1em;
    }
  }
`


export default TopConcept
